export enum CODIGOS_CONSULTA {

    CONSULTAR_RESPUESTA = 0,
    CONSULTA_NOVEDADES_RESUMEN = 1,
    CONSULTA_NOVEDADES_DETALLE = 2,
    CONSULTA_ENVIO_MANUAL_MORA = 3
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general_recibo/modelo/CodigosConsulta.ts